"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import makeStyles from "../../theming/make-styles.js";
import { defaultShadows } from "../button-base/button-base.js";
const useStyles = makeStyles()((theme, { disabled, shadow }) => ({
    group: {
        display: "inline-flex",
        borderRadius: theme.size(4),
        boxShadow: !!shadow && !disabled ? theme.shadow("sm") : undefined,
    },
}));
export const ButtonGroupContext = React.createContext({ buttonGroup: false });
export const ButtonGroup = React.forwardRef(function ButtonGroup(_a, ref) {
    var { children, className, color = "primary", disabled, size = "medium", variant = "filled", shadow = defaultShadows[variant] } = _a, props = __rest(_a, ["children", "className", "color", "disabled", "size", "variant", "shadow"]);
    const { classes, cx } = useStyles({ disabled, shadow });
    return (_jsx(ButtonGroupContext.Provider, { value: { buttonGroup: true, color, disabled, size, variant }, children: _jsx("div", Object.assign({ ref: ref, className: cx(classes.group, className), "data-component": "button-group", role: "group" }, props, { children: children })) }));
});
export default ButtonGroup;
//# sourceMappingURL=button-group.js.map